import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Globals } from '../../ressources/variables/globals';
import { CommonFunctionsService } from '../Global/commonFunctions.service';
import { AuthentificationService } from '../Global/authentification.service';

@Injectable()
export class SearchMusicsService {

  serverEndpoint = Globals.serverEndpoint;

  audio;
  audioPlaying = '';

  constructor(private http: HttpClient,
              private authentificationService: AuthentificationService,
              private CF: CommonFunctionsService) {
    this.audio = new Audio();
  }

  getPlaylistDeezer(playlistID, isAlbum=0, isTrack=0): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(this.serverEndpoint + '/api/getPlaylistMusics?playlistID=' + playlistID
      + '&isAlbum=' + isAlbum + '&isTrack=' + isTrack, { headers }).toPromise();
  }

  searchDeezer(search, index=0): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(this.serverEndpoint + '/api/searchMusics?search=' + this.CF.escapeSpecialsURL(search) + '&index=' + index, { headers }).toPromise();
  }

  searchAlbumDeezer(albumID): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.get(this.serverEndpoint + '/api/searchAlbum?album=' + albumID, { headers }).toPromise();
  }

  playextrait(src) {
    this.audio.pause();
    this.audio.currentTime = 0;
    this.audio.src = src;
    this.audioPlaying = src;
    this.audio.load();
    this.audio.play();
    this.audio.onended = () => {
      this.audio.currentTime = 0;
      this.audioPlaying = '';
    };
  }

  stopextrait() {
    this.audio.pause();
    this.audio.currentTime = 0;
    this.audioPlaying = '';
  }

  downloadMusicDeezer(musiqueUrl: string, folderName: string): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('musiqueUrl', musiqueUrl)
      .set('folderName', folderName);

    return this.http.post(this.serverEndpoint + '/api/downloadMusic', body.toString(), { headers }).toPromise();
  }

  /**
   * Télécharge un fichier audio
   * Note: L'authentification est gérée via les cookies de session Laravel
   * Le téléchargement via window.open transmettra automatiquement les cookies
   */
  downloadAudioFile(folder, filename): void {
    const url = `${this.serverEndpoint}/downloadAudioFile?folder=${folder}&filename=${this.CF.escapeSpecialsURL(filename.replace(/\+/gi, '%2B'))}`;

    window.open(url, '_blank');
  }
}
